export default "assets/images/icons/arrow-down-6636674b.svg";